/**
 * Unicode flag glyphs by country name (17 MVP European countries).
 * Uses regional indicator pairs — no image assets, no CDN, no per-country file.
 * Falls back to a globe glyph if the country name isn't in the table.
 */
const ISO2 = {
  "Austria":         "AT",
  "Belgium":         "BE",
  "Czech Republic":  "CZ",
  "Denmark":         "DK",
  "Finland":         "FI",
  "France":          "FR",
  "Germany":         "DE",
  "Hungary":         "HU",
  "Ireland":         "IE",
  "Italy":           "IT",
  "Netherlands":     "NL",
  "Norway":          "NO",
  "Poland":          "PL",
  "Portugal":        "PT",
  "Spain":           "ES",
  "Sweden":          "SE",
  "Switzerland":     "CH",
  "United Kingdom":  "GB",
  "Greece":          "GR",
  "Luxembourg":      "LU",
};

/** Convert an ISO-2 country code (e.g. "IT") to its 🇮🇹 emoji. */
function iso2ToFlag(iso2) {
  if (!iso2 || iso2.length !== 2) return "🌍";
  const A = 127397; // regional indicator offset from ASCII 'A'
  return String.fromCodePoint(...iso2.toUpperCase().split("").map(c => c.charCodeAt(0) + A));
}

/** Country name → flag emoji. */
export function flagFor(countryName) {
  return iso2ToFlag(ISO2[countryName]);
}

export default flagFor;
